// @ts-nocheck 5b4b429c
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_box'],
      sections: [addPanel.sections.getSections().box.containerBoxesSection],
    };
  },
};
